import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, Clock, Star } from "lucide-react";
import { useReviewStats } from "@/hooks/useReviewStats";

const CITY_LINKS = [
  { name: "Lausanne", slug: "lausanne" },
  { name: "Genève", slug: "geneve" },
  { name: "Yverdon", slug: "yverdon" },
  { name: "Montreux", slug: "montreux" },
  { name: "Nyon", slug: "nyon" },
  { name: "Fribourg", slug: "fribourg" },
  { name: "Neuchâtel", slug: "neuchatel" },
  { name: "Sion", slug: "sion" },
];

export default function Footer() {
  const reviewStats = useReviewStats();
  return (
    <footer className="bg-[#062133] text-white" data-testid="footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 sm:py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-12">
          <div>
            <div className="mb-4">
              <img
                src="/logo-white.png"
                alt="Nettoyage Expert"
                className="h-[80px] w-auto"
              />
            </div>
            <div className="space-y-3 text-sm text-white/70">
              <div className="flex items-start gap-2">
                <MapPin size={16} className="mt-0.5 shrink-0" />
                <span>Rue Jean-André Venel 4, 1400 Yverdon-les-Bains</span>
              </div>
              <div className="flex items-center gap-2">
                <Phone size={16} className="shrink-0" />
                <a href="tel:+41245391033" className="hover:text-white transition-colors">024 539 10 33</a>
              </div>
              <div className="flex items-center gap-2">
                <Mail size={16} className="shrink-0" />
                <a href="mailto:info@nettoyage-expert.ch" className="hover:text-white transition-colors">info@nettoyage-expert.ch</a>
              </div>
            </div>
          </div>

          <div>
            <h4 className="font-semibold mb-4">Pages</h4>
            <nav className="space-y-2 text-sm text-white/70">
              <Link to="/" className="block hover:text-white transition-colors">Accueil</Link>
              <Link to="/services" className="block hover:text-white transition-colors">Services</Link>
              <Link to="/contrats-entreprises" className="block hover:text-white transition-colors">Contrats Entreprises</Link>
              <Link to="/blog" className="block hover:text-white transition-colors">Blog</Link>
              <Link to="/a-propos" className="block hover:text-white transition-colors">À propos</Link>
              <Link to="/contact" className="block hover:text-white transition-colors">Contact</Link>
              <Link to="/avis-clients" className="block hover:text-white transition-colors">Avis clients</Link>
              <Link to="/plan-du-site" className="block hover:text-white transition-colors">Plan du site</Link>
              <Link to="/mentions-legales" className="block hover:text-white transition-colors">Mentions légales</Link>
              <Link to="/conditions-generales" className="block hover:text-white transition-colors">CGV</Link>
              <Link to="/politique-de-confidentialite" className="block hover:text-white transition-colors">Confidentialité</Link>
              <Link to="/politique-cookies" className="block hover:text-white transition-colors">Cookies</Link>
            </nav>
          </div>

          <div>
            <h4 className="font-semibold mb-4">Nos villes</h4>
            <nav className="space-y-2 text-sm text-white/70" data-testid="footer-city-links">
              {CITY_LINKS.map(city => (
                <Link key={city.slug} to={`/nettoyage-${city.slug}`} className="block hover:text-white transition-colors">
                  Nettoyage à {city.name}
                </Link>
              ))}
            </nav>
          </div>

          <div>
            <h4 className="font-semibold mb-4">Horaires</h4>
            <div className="space-y-2 text-sm text-white/70">
              <div className="flex items-start gap-2">
                <Clock size={16} className="mt-0.5 shrink-0" />
                <div>
                  <p>Lun-Mer : 08:00 - 18:00</p>
                  <p>Jeu : 08:00 - 18:00</p>
                  <p>Ven : 08:00 - 17:00</p>
                  <p>Sam : 09:00 - 12:30</p>
                </div>
              </div>
            </div>
            <a href="https://g.page/r/CTTcLCQur3ryEAE" target="_blank" rel="noopener noreferrer"
              className="mt-5 inline-flex items-center gap-2 px-3 py-2 bg-white/10 rounded-lg hover:bg-white/15 transition-colors" data-testid="footer-google-badge">
              <div className="flex gap-0.5">
                {Array.from({length:5},(_,i)=><Star key={i} size={12} className="fill-amber-400 text-amber-400" />)}
              </div>
              <span className="text-xs text-white/80 font-medium">5.0/5 — {reviewStats.count} avis Google</span>
            </a>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-white/40">&copy; {new Date().getFullYear()} Nettoyage Expert. Tous droits réservés.</p>
          <a href="https://g.page/r/CTTcLCQur3ryEAE" target="_blank" rel="noopener noreferrer"
            className="inline-flex items-center gap-1.5 text-xs text-white/60 hover:text-white transition-colors" data-testid="footer-google-link">
            <Star size={12} className="fill-amber-400 text-amber-400" /> 5.0/5 sur Google — {reviewStats.count} avis
          </a>
        </div>
      </div>
    </footer>
  );
}
